import { render, staticRenderFns } from "./sticky-ele.vue?vue&type=template&id=3877f630&"
import script from "./sticky-ele.vue?vue&type=script&lang=js&"
export * from "./sticky-ele.vue?vue&type=script&lang=js&"
import style0 from "./sticky-ele.vue?vue&type=style&index=0&lang=stylus&rel=stylesheet%2Fstylus&"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.4.2@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "sticky-ele.vue"
export default component.exports